import React, { useState, useEffect, useCallback, InputHTMLAttributes, Dispatch, SetStateAction } from 'react';
import { TextInput, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';

type FilterInputProps = {
  disabled?: boolean;
  value: string;
  onChange: Dispatch<SetStateAction<string>>;
};

type DebounceInputProps = FilterInputProps & {
  debounce?: number;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

const DebouncedInput = ({ disabled, value: initialValue, onChange, debounce = 500 }: DebounceInputProps) => {
  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  const onReset = useCallback(() => {
    setValue('');
  }, []);

  return (
    <TextInput
      placeholder={getMessage('placeholder-text__search')}
      showLabel={false}
      showReset
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
      onReset={onReset}
      value={value}
      disabled={disabled}
      prefix={<Icon glyph={Icon.set.SEARCH} />}
      testId="filter-input"
    />
  );
};

export const FilterInput = ({ disabled, value, onChange }: FilterInputProps) => {
  return <DebouncedInput value={value} onChange={onChange} disabled={disabled} />;
};
